import { acceptHMRUpdate, defineStore } from 'pinia'

// import { useApi } from '#imports'
// import { NAVIGATION } from '~/graphql/navigation'

export const useNavigationStore = defineStore('navigation', {
  state: () => ({
    currentL1: null,
    currentL1Layout: null,
    currentL2: null,
    currentLocale: null,
    currentRoute: null,
    currentCountry: null,
    header: [],
    menu: [],
    footer: [],
    footerCtas: [],
    latestNews: null,
    mobileNavOpen: false,
    searchPanelOpen: false,
    localePanelOpen: false,
    contactsPanelOpen: false,
    hubPanelOpen: false,
    hubPanelLayout: 'login',
    searchQuery: null,
    loading: false
  }),

  actions: {
    reset () {
      this.currentL1 = null
      this.currentL1Layout = null
      this.currentL2 = null
      this.mobileNavOpen = false
      this.searchPanelOpen = false
      this.localePanelOpen = false
      this.contactsPanelOpen = false
      this.hubPanelOpen = false
      this.hubPanelLayout = 'login'
    },

    resetL1L2 () {
      this.currentL1 = null
      this.currentL1Layout = null
      this.currentL2 = null
    },

    toggleMobileNav () {
      this.mobileNavOpen = !this.mobileNavOpen
      if (this.mobileNavOpen) {
        this.searchPanelOpen = false
        this.localePanelOpen = false
        this.contactsPanelOpen = false
        this.hubPanelOpen = false
      }
    },

    toggleSearchPanel () {
      this.searchPanelOpen = !this.searchPanelOpen
      if (this.searchPanelOpen) {
        this.mobileNavOpen = false
        this.localePanelOpen = false
        this.contactsPanelOpen = false
        this.hubPanelOpen = false
      }
    },

    toggleLocalePanel () {
      this.localePanelOpen = !this.localePanelOpen
      if (this.localePanelOpen) {
        this.mobileNavOpen = false
        this.searchPanelOpen = false
        this.contactsPanelOpen = false
        this.hubPanelOpen = false
      }
    },

    toggleContactsPanel () {
      this.contactsPanelOpen = !this.contactsPanelOpen
      if (this.contactsPanelOpen) {
        this.mobileNavOpen = false
        this.searchPanelOpen = false
        this.localePanelOpen = false
        this.hubPanelOpen = false
      }
    },

    toggleHubPanel () {
      this.hubPanelOpen = !this.hubPanelOpen
      if (this.hubPanelOpen) {
        this.mobileNavOpen = false
        this.searchPanelOpen = false
        this.localePanelOpen = false
        this.contactsPanelOpen = false
      }
    },

    setCurrentLocale (locale) {
      this.currentLocale = locale
    },

    setCurrentRoute (route) {
      this.currentRoute = route
    },

    setCurrentCountry (country) {
      this.currentCountry = country
    },

    setSearchQuery (query) {
      this.searchQuery = query
    },

    async getNavigations () {
      try {
        // TODO: Implement actual GraphQL call when schema is ready
        // const { header, menu, footer, footerCtas, latestNews } = await useApi(NAVIGATION)
        // this.header = header || []
        // this.menu = menu || []
        // this.footer = footer || []
        // this.footerCtas = footerCtas || []
        // this.latestNews = latestNews

        // For now, use mock data that matches the old project structure
        this.header = []
        this.menu = []
        this.footer = []
        this.footerCtas = []
        this.latestNews = null

        // console.log('[INFO] Navigation data loaded (mock)')
      } catch (err) {
        console.error('[ERROR] Error fetching navigation', err)
      }
    },

    getLinkProps (node) {
      return {
        ...(node?.element ? { to: '/' + node.element.uri } : { tag: 'div' }),
        ...(node?.type?.includes('CustomType') ? { href: node.url, target: '_blank' } : {})
      }
    }
  },

  getters: {
    isMobileNavOpen (state) {
      // Safe getter without layout store dependency
      return state.mobileNavOpen
    },
    getCurrentL1Layout (state) {
      return state.currentL1Layout
    },
    isContactsPanelOpen: state => state.contactsPanelOpen,
    isSearchPanelOpen: state => state.searchPanelOpen,
    isLocalePanelOpen: state => state.localePanelOpen,
    isHubPanelOpen: state => state.hubPanelOpen,
    isLoading: state => state.loading
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNavigationStore, import.meta.hot))
}
